import { baseGlobals } from '@root/typescript/baseGlobals'

import { is } from '@common/is/is'

import './Text.css'

import { TRANSLATE_CHANGED_EVENT } from '@common/i18n/v1/translate'

import getText from './utils/getText'
import onTranslateChanged from './utils/onTranslateChanged'

interface IProps {
  readonly key: string
  readonly className?: string
  readonly replace?: string
}

document.addEventListener(TRANSLATE_CHANGED_EVENT, onTranslateChanged)

export default class Text extends HTMLElement {
  /**
   * Egy Text komponens példányosítása.
   * @param props - A lehetséges beállítások.
   */
  public static instance (props: IProps): HTMLElement { // eslint-disable-line no-restricted-syntax
    const txt = getText(props.key, props.replace ?? null)

    const text: HTMLSpanElement = (
      <span
        className={ [ 'sen-text', is.string(props.className) ? props.className : '' ] }
        dangerouslySetInnerHTML={ { __html: txt } }
      />
    )

    document.addEventListener(TRANSLATE_CHANGED_EVENT, () => {
      text.innerHTML = getText(props.key)
    })

    return text
  }

  public connectedCallback (): void {
    this.classList.add('sen-text')
    this.refresh()
  }

  /** A nyelvi komponens frissítése, általában nyelvváltáskor. */
  public refresh (): void {
    const key = this.getAttribute('key')
    const replace = this.getAttribute('replace')

    const txt = getText(key, replace)

    if (!is.empty(txt)) {
      this.innerHTML = txt
    }
    else if (baseGlobals.isDev) {
      this.innerHTML = key ?? ''
    }
  }
}

// Vannak olyan projectjeink, ahol nincs customElements, mert nincs szükség rá, viszont sima Text komponenst használni szeretnénk.
// Tesztkörnyezetben is kell definiálni.
if (is.property(window, 'customElements') || baseGlobals.isTest) {
  customElements.define('sen-text', Text)
}
